import * as React from 'react';

import Text from 'components/Text';

type Props = {
  count: number;
  unitText?: boolean;
  className?: string;
};

function getUnitText(count: number): string {
  const unitsRemaining = count === 1 ? 'character left' : 'characters left';
  return count < 0 ? 'characters' : unitsRemaining;
}

const RemainingCharactersCount = ({ count, unitText, className }: Props) => {
  const textColor = count < 0 ? 'apple' : 'graphite';
  const displayString = `${count}${unitText ? ' ' + getUnitText(count) : ''}`;

  // if there are more than 300 characters left
  // show nothing
  if (count > 300) {
    return null;
  }
  return (
    <Text
      color={textColor}
      size="xxsmall"
      className={className}
      data-test="character-count"
      data-test-selector="character_count"
      data-testid="ComposerForm-RemainingCharactersCount"
    >
      {displayString}
    </Text>
  );
};

export default RemainingCharactersCount;
